type Listener = (visible: boolean) => void;

let guestHeroStatsOnScreen = false;
const listeners = new Set<Listener>();

export function setGuestHeroStatsOnScreen(next: boolean) {
  if (guestHeroStatsOnScreen === next) return;
  guestHeroStatsOnScreen = next;
  listeners.forEach((listener) => listener(guestHeroStatsOnScreen));
}

export function subscribeGuestHeroStatsOnScreen(listener: Listener) {
  listeners.add(listener);
  listener(guestHeroStatsOnScreen);
  return () => {
    listeners.delete(listener);
  };
}
